import './footer.css'
import React from 'react'
// components
import { 
  AiFillInstagram,
  AiFillLinkedin,
  AiFillGithub
} from 'react-icons/ai'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>OLIVA</a>
      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.instagram.com/__labhishek/"><AiFillInstagram /></a>
        <a href="https://www.linkedin.com/in/abhishek-yadav-142a03225/"><AiFillLinkedin /></a>
        <a href="https://github.com/Abhishek-Yadav-web"><AiFillGithub /></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; OLIVA | Abhishek Yadav. All rights reserved.</small>
      </div>

    </footer>
  )
}

export default Footer